<!-- 图文分离组件 -->
<template>
  <div
    class="advance-imgTxt-three"
    :style="{
      backgroundImage: `url(${$attrs.backgroundImage})`
    }"
  >
    <div
      class="content"
      :style="{'--maxWidth': $attrs.maxWidth}"
    >
      <!-- 主标题 -->
      <div
        class="main-title"
        v-if="mainTitle.show"
        :style="transfCss.mainTitle"
      >
        <TextEdit
          change-key="mainTitle"
          :text.sync="mainTitle.desc"
          :mode="textEdit"
          :sendData="mainTitle"
          v-on="$listeners"
        />
      </div>
      <!-- 副标题 -->
      <div
        class="sub-title"
        v-if="subTitle && subTitle.show"
        :style="transfCss.subTitle"
      >
        <TextEdit
          change-key="subTitle"
          :text.sync="subTitle.desc"
          :mode="textEdit"
          :sendData="subTitle"
          v-on="$listeners"
        />
      </div>
      <!-- 滑块 -->
      <swiper
        ref="mySwiper"
        :options="swiperOptions"
        :class="[cardProps.shadow ? 'site-swiper-container' : '']"
      >
        <swiper-slide
          v-for="(item, index) in $attrs.imgTxtList"
          class="swiper-slider"
          :key="index"
        >
          <div
            class="cms-card-box"
            :class="[cardProps.shadow ? 'cms-card-box-shadow' : '']"
            :style="{
              '--borderColor': cardProps.borderColor,
              ...transfCss.cardProps,
              background: item.backgroundImage ? `no-repeat center bottom/100% 100% url(${item.backgroundImage})` : '',
              backgroundColor: item.backgroundColor,
              cursor: item.link ? 'pointer' : 'auto',
              textAlign: cardProps.layout
            }"
          >
            <!-- 内容图片 -->
            <div
              v-if="item.icons.show"
              class="img-container"
              @click.prevent="handleClickItem(index, 5, $event)"
            >
              <img
                :src="item.icons.url"
                :style="transfCssUtil(item.icons)"
              />
            </div>
            <!-- 循环列表 -->
            <div class="content-text-box">
              <div
                class="content-text-item"
                :class="{ 'is-point': l.link }"
                v-for="(l, lIndex) of item.list"
                :key="lIndex"
                @click.stop="openUrl(l.link)"
              >
                <!-- 主标题 -->
                <div
                  class="item-main-title c-font-regular-16"
                  :style="transfCssUtil(l.mainTitle)"
                  @click.prevent="handleClickItem(index, 9, $event)"
                >
                  <TextEdit
                    change-key="imgTxtList"
                    :text.sync="l.mainTitle.desc"
                    :mode="textEdit"
                    :sendData="$attrs.imgTxtList"
                    v-on="$listeners"
                  />
                </div>
                <!-- 副标题 -->
                 <div
                  class="item-sub-title c-font-regular-12"
                  :style="transfCssUtil(l.subTitle)"
                >
                  <TextEdit
                    change-key="imgTxtList"
                    :text.sync="l.subTitle.desc"
                    :mode="textEdit"
                    :sendData="$attrs.imgTxtList"
                    v-on="$listeners"
                  />
                </div>
              </div>
            </div>
          </div>
        </swiper-slide>
        <div
          class="swiper-button-prev swiper-button swiper-button-black"
          slot="button-prev"
          :style="{ display: !option.openNavigation ? 'none' : 'block' }"
        ></div>
        <div
          class="swiper-button-next swiper-button swiper-button-black"
          slot="button-next"
          :style="{ display: !option.openNavigation ? 'none' : 'block' }"
        ></div>
      </swiper>
    </div>
  </div>
</template>
<script>
import 'swiper/dist/css/swiper.css'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import merge from 'lodash/merge'
import { transfCssUtil, isMobile } from '../../utils/index'
import mixin from '../../utils/mixin'
import TextEdit from '../common/TextEdit.vue'
export default {
  props: ['option'],
  mixins: [mixin],
  data () {
    return {
      swiperOptions: {},
      isNoSwipper: true,
      transfCssUtil,
      isMobile
    }
  },
  computed: {
    swiper () {
      return this.$refs.mySwiper.swiper
    },
    transfCss () {
      const { mainTitle, subTitle, padding, cardProps } = this.$attrs
      return this.transfCssUtil({
        mainTitle,
        subTitle,
        padding,
        cardProps
      })
    },
    mainTitle () {
      return this.$attrs.mainTitle
    },
    subTitle () {
      return this.$attrs.subTitle
    },
    cardProps () {
      return this.$attrs.cardProps
    }
  },
  created () {
    this.initOptions()
  },
  methods: {
    initOptions () {
      const option = this.option
      if (!option.autoplay.is) {
        option.autoplay = false
      }
      this.swiperOptions = merge({
        direction: 'horizontal',
        autoplayDisableOnInteraction: false,
        observer: true,
        observeParents: true,
        noSwiping: true,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
          disabledClass: option.openNavigation ? 'my-button-disabled' : 'my-button-hidden'
        },
        breakpoints: {
          1024: {
            slidesPerView: 3,
            spaceBetween: 40,
          },
          768: {
            slidesPerView: 2,
            spaceBetween: 40,
          },
          480: {
            slidesPerView: 1,
            spaceBetween: 40,
          }
        }
      }, option)
    }
  },
  watch: {
    option (val) {
      this.$nextTick(() => {
        if (this.swiper) {
          this.swiper.params = merge(this.swiper.params, val)
          this.swiper.navigation.$prevEl.css('display', !val.openNavigation ? 'none' : 'block')
          this.swiper.navigation.$nextEl.css('display', !val.openNavigation ? 'none' : 'block')
          this.swiper.update()
        }
      })
    },
    'option.autoplay.is': {
      handler (val) {
        if (val) {
          this.swiper.autoplay.start()
        } else {
          this.swiper.autoplay.stop()
        }
      },
      immeidate: true,
      deep: true
    }
  },
  components: {
    swiper,
    swiperSlide,
    TextEdit
  }
}
</script>
<style lang="stylus" scoped>
.advance-imgTxt-three
  background-repeat no-repeat
  background-size cover
  background-position 50%
  .site-swiper-container
    padding-bottom: 20px;
  .content
    max-width var(--maxWidth, 1200px)
    margin 0 auto
    .main-title
      font-size 28px
      line-height 40px
      font-weight 600
    .sub-title
      font-size 14px
      font-weight 400
      line-height 22px
      white-space pre-line
  .swiper-slider
    box-sizing border-box
    position relative
    height auto
  .swiper-button
    width 40px
    height 40px
    background-color rgba(255, 255, 255, 0.9)
    background-size 15px 15px
    border-radius 50%
    box-shadow 0px 4px 15px 0px rgba(14, 66, 210, 0.2)
  .my-button-disabled
    cursor not-allowed
    opacity 0.2
  .my-button-hidden
    display none
  .cms-card-box
    box-sizing border-box
    height 100%
    overflow hidden
    border 1px solid var(--borderColor)
  .content-sub-title
    font-size 14px
    line-height 22px
    font-weight 400
  .img-container
    width 100%
    font-size 0
    overflow hidden
  .cms-card-box-shadow
    box-shadow: 0px 8px 20px 0px #3763AA1A;
  .content-text-box {
    padding: 0 24px 24px;
    .content-text-item {
      padding: 24px 0;
      border-bottom: 1px solid var(--border_1)
      &:last-child {
        border-bottom: none
      }
    }
    .is-point {
      cursor: pointer;
    }
  }
</style>

